import { render, staticRenderFns } from "./PopupJobDesc.vue?vue&type=template&id=506931c4&"
import script from "./PopupJobDesc.vue?vue&type=script&lang=js&"
export * from "./PopupJobDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports